import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import GroupListing from "./GroupListing/GroupListing";
import GetStarted from "./GetStarted";
import ScreenHeader from "../../../CommonComponents/ScreenHeader";
import TabNav from "../../../CommonComponents/TabNav/TabNav";

const Directory = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    if (location.pathname.includes("/groupListing")) {
      return "groupListing";
    }
    return "getStarted";
  };

  const menuItems = [
    {
      key: "groupListing",
      label: "Group Listing",
    },
    {
      key: "getStarted",
      label: "Get Started",
    },
  ];

  const handleTabChange = (tabKey) => {
    switch (tabKey) {
      case "groupListing":
        navigate("/admin/directory/groupListing");
        break;
      case "getStarted":
        navigate("/admin/directory/getStarted");
        break;
      default:
        navigate("/admin/directory/groupListing");
    }
  };

  const renderContent = () => {
    if (location.pathname.includes("/groupListing")) {
      return <GroupListing handleTabChange={handleTabChange} />;
    }
    return <GetStarted />;
  };

  return (
    <div className="directory-container" style={{ padding: "12px" }}>
      <ScreenHeader title="Directory" />

      <div style={{ paddingTop: "2px" }}>
        <TabNav
          items={menuItems}
          activeKey={getCurrentTab()}
          handleTabChange={handleTabChange}
        />
      </div>
      <div className="directory-content">{renderContent()}</div>
    </div>
  );
};

export default Directory;
